/**
 * Helper для кнопки «Попробовать сейчас» в сценах 5/6/7/8/9/10.
 *
 * Все эти кнопки скроллят в #scene-final. Дополнительно мы запоминаем
 * id сцены, из которой пришли — чтобы BackToPrevious (стрелка в правом
 * нижнем углу) умел вернуть юзера именно в ту сцену, а не куда попало.
 *
 * Если юзер «Попробовать сейчас» не нажимал — BackToPrevious читает
 * пустой trySource и просто скроллит в начало страницы.
 *
 * Хранилище: sessionStorage (живёт до закрытия вкладки/перезагрузки).
 * Не используем module-level state, потому что BackToPrevious и Scene-кнопки
 * монтируются в разных поддеревьях и любая клиент-навигация может их пересоздать.
 */

const STORAGE_KEY = 'favbox-landing-try-source';

export const SCENE_IDS = [
  'scene-stream',
  'scene-overflow',
  'scene-mascot',
  'scene-trust',
  'scene-categories',
  'scene-covers',
  'scene-swipe',
  'scene-magic',
  'scene-voting',
  'scene-stories',
  'scene-faq',
  'scene-final',
] as const;

/** Активная сцена = последняя, чей top уже выше 30% viewport. */
function findActiveSceneId(): string | null {
  if (typeof window === 'undefined') return null;
  const anchor = window.innerHeight * 0.3;
  let active: string | null = null;
  for (const id of SCENE_IDS) {
    const el = document.getElementById(id);
    if (!el) continue;
    const rect = el.getBoundingClientRect();
    if (rect.top <= anchor) {
      active = id;
    } else {
      break;
    }
  }
  return active;
}

/** Сохраняем точку отправки и скроллим в финал. */
export function tryCtaScrollToFinal(): void {
  if (typeof window === 'undefined') return;
  const source = findActiveSceneId();
  // не пишем 'scene-final' (нечего возвращать) и не пишем пусто
  if (source && source !== 'scene-final') {
    try {
      sessionStorage.setItem(STORAGE_KEY, source);
    } catch {
      /* Safari private mode / quota — игнорируем */
    }
  }
  document.getElementById('scene-final')?.scrollIntoView({ behavior: 'smooth' });
}

export function getTrySource(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearTrySource(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* пусто */
  }
}
